import React from 'react'
import PropTypes from 'prop-types'

import MenuList from './MenuList'
import MenuCategory from './MenuCategory'

class Menus extends React.Component {
  render() {
    const { menus, selectedOrders, openModal } = this.props
    const orderIds = selectedOrders.map(order => order.id)

    return (
      <div id="sticky-categories-boundary">
        <MenuCategory categories={menus.map(m => m.name)} />

        {menus.map(category => (
          <MenuList
            key={`category-${category.id}`}
            orders={orderIds}
            openModal={openModal}
            {...category}
          />
        ))}
      </div>
    )
  }
}

Menus.propTypes = {
  openModal: PropTypes.func,
  selectedOrders: PropTypes.array,
  addToOrder: PropTypes.func,
  location: PropTypes.object,
  match: PropTypes.object,
  actions: PropTypes.object,
  menus: PropTypes.array,
}

export default Menus
